const AI_APP_ID = "ai";
function visibleApps(apps, ctx) {
  if (ctx.sharedDevice || ctx.availabilityOnly || ctx.teamPending) return [];
  return apps.filter((app) => passes(app.requires, ctx)).map((app) => withUrl(app, ctx));
}
function passes(requires, ctx) {
  if (!requires) return true;
  const { workspace, homePage, anyPermission, adminOnly, controllerAccess } = requires;
  if (workspace !== void 0) {
    if (!ctx.workspaces.has(workspace)) return false;
    if (homePage && !ctx.hasHomePage(workspace)) return false;
  }
  const hasAnyPermission = (anyPermission ?? []).some((key) => ctx.permissions.has(key));
  if (anyPermission !== void 0 && !ctx.isAdmin && !hasAnyPermission) return false;
  if (adminOnly && !ctx.isAdmin) return false;
  if (controllerAccess && !ctx.controllerAccess) return false;
  return true;
}
function withUrl(app, ctx) {
  if (app.id !== AI_APP_ID) return { ...app };
  const ai = { ...app, url: safeHttpUrl(ctx.aiUrl) };
  delete ai.nextUrl;
  return ai;
}
function safeHttpUrl(value) {
  if (!value) return null;
  try {
    const url = new URL(value);
    return url.protocol === "http:" || url.protocol === "https:" ? value : null;
  } catch {
    return null;
  }
}
export {
  AI_APP_ID,
  visibleApps
};
//# sourceMappingURL=visibleApps.js.map
